import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=2725a0a9&scoped=true"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=2725a0a9&prod&lang=less&scoped=true"
import style1 from "./FaqItem.vue?vue&type=style&index=1&id=2725a0a9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725a0a9",
  null
  
)

export default component.exports